"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROWS_PER_PAGE_OPTIONS = void 0;
exports.ROWS_PER_PAGE_OPTIONS = [
    {
        label: '10',
        value: 10,
    },
    {
        label: '25',
        value: 25,
    },
    {
        label: '50',
        value: 50,
    },
    {
        label: '75',
        value: 75,
    },
    {
        label: '100',
        value: 100,
    },
];
